﻿import { FIQAssist } from "../../app";
import { Inject, Injectable } from "@fiqas/angular-utils";
import { FiqassistApiServiceBase } from "./fiqassistApiServiceBase";
import { AuthenticationService } from "../authenticationService"
import { FqsService  } from "../fqsService"
import { AuthorizationService } from "../authorizationService";

@Injectable({
    module: FIQAssist,
    selector: FiqassistService.selector
})
export class FiqassistService extends FiqassistApiServiceBase {
    public static selector = "FiqassistService"
    constructor(
        @Inject('$q') $q: angular.IQService,
        @Inject('$http') $http: angular.IHttpService,
        @Inject() authenticationService: AuthenticationService,
        @Inject() authorizationService: AuthorizationService,
    ) {
        super($q, $http, authenticationService, authorizationService);
    }
}
